<app-navbar></app-navbar>

<div class="container-fluid desma-page">
  <div class="row">
    <nav class="col-md-3 col-lg-2 d-md-block sidebar desma-sidebar">
      <div class="sidebar-sticky">
        <ul class="nav flex-column">
          <li class="nav-item">
            <a class="nav-link" routerLink="/electric-cars">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Electric Cars</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link active" routerLink="/design-and-manufacturing">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Design and Manufacturing</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/auto-electrical">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Auto Electrical of an Electric Scooter</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/iot">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Internet of Things</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/charger-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Charger Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/solar-installation">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Solar Installation</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/welding">
              <i class="fa fa-book" aria-hidden="true"></i>
              <span>Welding</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <main role="main" class="col-md-9 col-lg-10 ms-sm-auto px-3 px-md-4 py-4 desma-content">
      <section class="course-header">
        <p class="course-tag">FEA Course</p>
        <h1>Design and Manufacturing</h1>
        <p class="course-subtitle">Learn practical manufacturing principles, design thinking, and material selection through guided video lessons.</p>
      </section>

      <section class="lesson-grid">
        <article class="lesson-card">
          <h4><span>01</span> Introduction to Design and Manufacturing</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FDesign-and-Manufacturing-Elizabeth-Nyakotey%2FElizabeth%20(Design%20And%20Manufacturing).mp4?alt=media&token=1badb763-d268-4ee2-a0cb-d1ee3df872cd" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>02</span> Principles of Design Manufacturing</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FDesign-and-Manufacturing-Elizabeth-Nyakotey%2FElizabeth%20(Principles%20Of%20DFM).mp4?alt=media&token=205c6f0f-b8ca-4da0-8e51-8d39a067dcbb" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>03</span> Design Thinking</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FDesign-and-Manufacturing-Elizabeth-Nyakotey%2FElizabeth%20(Design%20Thinking).mp4?alt=media&token=0882fe8c-ec9e-465a-aac2-11bcf733a417" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>04</span> Material Selection</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FDesign-and-Manufacturing-Elizabeth-Nyakotey%2FElizabeth%20(Materials%20Selection).mp4?alt=media&token=45e315fa-88f0-4686-9337-450c96ce481f" type="video/mp4">
          </video>
        </article>

        <article class="lesson-card">
          <h4><span>05</span> Behavioral Properties of Materials</h4>
          <video controls controlsList="nodownload">
            <source src="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FDesign-and-Manufacturing-Elizabeth-Nyakotey%2FElizabeth%20(Behavioral%20Properties%20Of%20Materials).mp4?alt=media&token=58166df5-6f65-44c4-999c-a703ccddcbcd" type="video/mp4">
          </video>
        </article>
      </section>

      <section class="course-actions">
        <a class="btn solarorange" href="https://firebasestorage.googleapis.com/v0/b/solar-academy-18d4c.appspot.com/o/FEA-Videos-Cohort-3%2FDesign-and-Manufacturing-Elizabeth-Nyakotey%2FFemale%20Engineering%20Academy(Notes).docx?alt=media&token=dc6520d2-1204-42c4-976e-d143e15e7f05" target="_blank" rel="noopener noreferrer">
          Download Course Material
        </a>

        <a class="btn solarblue" href="https://docs.google.com/forms/d/e/1FAIpQLSdVjIjUNtfXXL95gfNHygQch4i0onJx9ueK9MWdvPXXgiV-8w/viewform" target="_blank" rel="noopener noreferrer">
          Take Assessment
        </a>

        <button type="button" class="btn solarorange complete-btn" (click)="completed()">
          Mark Completed
        </button>
      </section>
    </main>
  </div>
</div>
